import { createSlice } from '@reduxjs/toolkit';
const serviceFee: any = {};
const filters: any = {};

const serviceFeesReducer = createSlice({
	name: 'serviceFees',
	initialState: {
		isLoading: false,
		serviceFees: [],
		serviceFee,
		filters,
		pagination: {
			totalCount: 0,
			totalPages: 0,
			currentPage: 1,
			limit: 10,
			hasNextPage: false,
			hasPrevPage: false,
		},
	},
	reducers: {
		setServiceFeesIsLoading: (state) => {
			state.isLoading = true;
		},
		resetServiceFeesIsLoading: (state) => {
			state.isLoading = false;
		},
		setServiceFees: (state, action) => {
			state.serviceFees = action.payload;
		},
		setServiceFeesPagination: (state, action) => {
			state.pagination = action.payload;
		},
		resetServiceFees: (state) => {
			state.serviceFees = [];
			state.pagination = {
				totalCount: 0,
				totalPages: 0,
				currentPage: 1,
				limit: 10,
				hasNextPage: false,
				hasPrevPage: false,
			};
		},
		setServiceFee: (state, action) => {
			state.serviceFee = action.payload;
		},

		resetServiceFee: (state) => {
			state.serviceFee = {};
		},

		setServiceFeesFilters: (state, action) => {
			state.filters = action.payload;
		},

		resetServiceFeesFilters: (state) => {
			state.filters = {};
		},
	},
});
export const {
	setServiceFeesIsLoading,
	resetServiceFeesIsLoading,
	setServiceFee,
	resetServiceFee,
	setServiceFees,
	setServiceFeesPagination,
	resetServiceFees,
	setServiceFeesFilters,
	resetServiceFeesFilters,
} = serviceFeesReducer.actions;
export default serviceFeesReducer.reducer;
